import { render } from "./BalBlankSlate.vue?vue&type=template&id=f445fda0&ts=true"
import script from "./BalBlankSlate.vue?vue&type=script&lang=ts"
export * from "./BalBlankSlate.vue?vue&type=script&lang=ts"

import "./BalBlankSlate.vue?vue&type=style&index=0&id=f445fda0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__